// src/components/EmployeeListFilter.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { fetchDepartments } from "../store/slices/EmployeeSlice";
import { Link } from "react-router-dom";

const EmployeeListFilter = ({  onSearch, showDisabledOnly = false, setShowDisabledOnly }) => {
  const dispatch = useDispatch();
  const departments = useSelector((state) => state?.employee?.departments);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [focused, setFocused] = useState(false);
  const [focused1, setFocused1] = useState(false);
  const { userDetails } = useSelector((state) => state?.user); // Get user from Redux store
  const { role: userRole } = userDetails?.data?.user || {}; // Extract user role
  const isManager = userRole === "manager"; // Check for manager role

  useEffect(() => {
    dispatch(fetchDepartments());
  }, [dispatch]);

  const handleSearch = (newDepartment = selectedDepartment) => {
    onSearch({
      employeeId,
      employeeName,
      department: newDepartment,
      showDisabledOnly // Pass this to the parent component
    });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmployeeId(value);
  };

  const handleInputChange2 = (e) => {
    const value = e.target.value;
    setEmployeeName(value);
  };

  const handleDepartmentChange = (option) => {
    setSelectedDepartment(option);
  };

 const toggleDisabledUsers = (e) => {
  e.preventDefault();
  const newState = !showDisabledOnly;
  setShowDisabledOnly(newState);
  
  // Clear other filters when toggling
  setEmployeeId("");
  setEmployeeName("");
  setSelectedDepartment(null);
  
  onSearch({
    showDisabledOnly: newState,
    employeeId: "",
    employeeName: "",
    department: null
  });
};
  const dropdownStyle = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#cb6ce6"
        : state.isFocused
        ? "#f8defff5"
        : undefined,
      color: state.isSelected ? "#fff" : undefined,
      "&:active": {
        backgroundColor: "#f8defff5",
      },
    }),
  };
  return (
    <div>
      <div className="row filter-row">
        <div className="col-sm-6 col-md-2">
          <div
            className={
              focused || employeeId !== ""
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <input
              type="text"
              className="form-control floating"
              value={employeeId}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(employeeId !== "")}
              onChange={handleInputChange}
            />
            <label className="focus-label" onClick={() => setFocused(true)}>
              Employee ID
            </label>
          </div>
        </div>
        <div className="col-sm-6 col-md-2">
          <div
            className={
              focused1 || employeeName !== ""
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <input
              type="text"
              className="form-control floating"
              value={employeeName}
              onFocus={() => setFocused1(true)}
              onBlur={() => setFocused1(employeeName !== "")}
              onChange={handleInputChange2}
            />
            <label className="focus-label" onClick={() => setFocused1(true)}>
              First Name
            </label>
          </div>
        </div>
        {!isManager && (
          <div className="col-sm-6 col-md-3">
            <div className="input-block form-focus select-focus">
              <Select
                options={[
                  { value: null, label: "All" },
                  ...departments.map((dept) => ({
                    value: dept._id,
                    label: dept.name,
                  })),
                ]}
                placeholder="Select Department"
                styles={dropdownStyle}
                onChange={handleDepartmentChange}
                value={selectedDepartment}
              />
              <label className="focus-label">Department</label>
            </div>
          </div>
        )}
        <div className="col-sm-6 col-md-3">
          <Link
            className={`btn btn-block w-100 ${showDisabledOnly ? "btn-success"  : "btn-secondary"}`}
            onClick={toggleDisabledUsers}
          >
            {showDisabledOnly ? "Active Users" : "Disabled Users"}
          </Link>
        </div>
        <div className="col-sm-6 col-md-2">
          <Link
            className="btn btn-success btn-block w-100"
            onClick={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            Search
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListFilter;